import React from 'react';

const DisclaimerPage = () => {
  return (
    <div className="container mx-auto py-10 px-6">
      <h1 className="text-3xl font-bold mb-6">Disclaimer</h1>
      <p className="mb-4">
        This service is powered by cutting-edge AI technology designed to provide an initial assessment of watch authenticity. However, it is important to note that the results generated by this service are not guaranteed to be 100% accurate. The AI system aims to provide as close an assessment as possible based on the data provided but should not be considered a definitive or final judgment.
      </p>
      <p className="mb-4">
        Users are strongly encouraged to use this service as a preliminary step and consult authorized experts or professionals for a more thorough and conclusive evaluation. The results provided by this service should not be the sole basis for making decisions regarding the authenticity or value of a watch.
      </p>
      <p className="mb-4">
        We do not take responsibility for any decisions, actions, or outcomes resulting from the use of this service. The AI technology employed in this service analyzes the provided images and videos to the best of its ability but is subject to limitations inherent in any automated system.
      </p>
      <p className="mb-4">
        By using this service, you acknowledge and agree that:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>The results are generated by AI and are not a substitute for professional evaluation.</li>
        <li>The service is provided "as is" without any warranties, express or implied.</li>
        <li>We are not liable for any inaccuracies, errors, or omissions in the results.</li>
        <li>You assume full responsibility for any decisions made based on the results provided.</li>
      </ul>
      <p className="mb-4">
        For further verification and peace of mind, we recommend consulting authorized experts or certified professionals who specialize in watch authentication.
      </p>
      <p className="mb-4">
        Thank you for using our service. We are committed to continuously improving our technology to provide the best possible experience for our users.
      </p>

      <h1 id="terms-of-service" className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">
        By using this service, you agree to the following terms and conditions:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>You must provide accurate and complete information when using the service.</li>
        <li>The service is intended for personal use only and may not be used for commercial purposes without prior authorization.</li>
        <li>We reserve the right to modify or discontinue the service at any time without notice.</li>
        <li>Unauthorized use of the service may result in termination of access and legal action.</li>
        <li>All intellectual property rights related to the service remain the property of the service provider.</li>
      </ul>
      <p className="mb-4">
        These terms are subject to change, and it is your responsibility to review them periodically. Continued use of the service constitutes acceptance of any changes.
      </p>

      <h1 id="privacy-policy" className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our service. By using this service, you agree to the terms of this Privacy Policy.
      </p>
      <h2 className="text-2xl font-bold mb-4">Information We Collect</h2>
      <p className="mb-4">
        We may collect the following types of information:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Personal information you provide, such as your name, email address, and payment details.</li>
        <li>Images and videos you upload for analysis.</li>
        <li>Technical data, such as your IP address, browser type, and operating system.</li>
      </ul>
      <h2 className="text-2xl font-bold mb-4">How We Use Your Information</h2>
      <p className="mb-4">
        The information we collect is used to:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Provide and improve our services.</li>
        <li>Process payments and deliver results.</li>
        <li>Communicate with you regarding your use of the service.</li>
        <li>Ensure the security and functionality of our platform.</li>
      </ul>
      <h2 className="text-2xl font-bold mb-4">Data Protection</h2>
      <p className="mb-4">
        We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
      </p>
      <h2 className="text-2xl font-bold mb-4">Sharing Your Information</h2>
      <p className="mb-4">
        We do not sell or rent your personal information to third parties. We may share your information with trusted third-party service providers who assist us in operating our platform, conducting our business, or providing services to you, provided they agree to keep your information confidential.
      </p>
      <h2 className="text-2xl font-bold mb-4">Your Rights</h2>
      <p className="mb-4">
        You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us using the information provided in the "Contact Us" section.
      </p>
      <h2 className="text-2xl font-bold mb-4">Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page, and your continued use of the service constitutes acceptance of the updated policy.
      </p>

      <h1 id="contact-us" className="text-3xl font-bold mb-6">Contact Us</h1>
      <p className="mb-4">
        [Contact information will be added here.]
      </p>
    </div>
  );
};

export default DisclaimerPage;